export default __webpack_public_path__ + "static/media/Shot_27.0000.c1f01403.png";